import { useIntl } from "react-intl";
import { useQuery } from "react-query";

import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  ListRequestOfBaseFilter,
  ListResponseOfSkuAvailability,
  SkuAvailability,
} from "services/KnowfullyAdminClient";

type SelectSkuAvailabilityProps = Omit<
  AutocompleteWithQueryProps<SkuAvailability>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectSkuAvailability = ({ ...rest }: SelectSkuAvailabilityProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchedSkuAvailabilities = useQuery<ListResponseOfSkuAvailability>(
    ["SkuAvailabilities"],
    () =>
      skuService.getSkuAvailabilities(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedSkuAvailabilities}
      failMessage={t({ id: "selectSkuAvailabilityFetchFailed" })}
    />
  );
};

export default SelectSkuAvailability;
